/* eslint-disable no-unused-vars  */
/* eslint-disable consistent-return */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-nested-ternary */

'use strict';

var toastr = require('toastr');
var util = require('./util');
var ajax = require('./ajax');
var progress = require('./progress');
var preLoader = require('./progress');
var isMobile = !($(window).width() >= 768);

var precentTotal;
var aunit;
var selectedProdVal = [];
var itemTotal = 0;
var finalLyeTotal = 0;
var finalLyeLiquidTotal = 0;
var selectedProductId;
var selectedProductName = null;

/**
 * function to update the count of selected products
 */
function updateCount() {
    var count = $('#lc-dynacmic-grid li').length;
    $('.js-number-of-product').text('(' + count + ')');
    // update the percentage value as well
    precentTotal = 0;
    var selectedUnit = $('#select-lc-step1-unit li.selected').attr('data-value');
    if (selectedUnit === 'Percentage') {
        var totalProductCount = $('#lc-dynacmic-grid>ul :input').length;
        for (var lindex = 0; lindex < totalProductCount; lindex++) {
            var enteredValue = $('#lc-dynacmic-grid>ul>li>div #tb-lc-step2')[lindex]
                .value;
            if (
                enteredValue !== null &&
				enteredValue !== '' &&
				!Number.isNaN(enteredValue) &&
				parseFloat(enteredValue) > 0
            ) {
                precentTotal += parseFloat(enteredValue);
            }
        }
        $('#lc-dynacmic-calc-up').html('Total ' + precentTotal + '%');
        if (precentTotal === 100) {
            $('#lc-dynacmic-calc-up').css('color', 'green');
            $('#lc-dynacmic-calc-error-up').addClass('lc-dynacmic-calc-error');
        } else {
            $('#lc-dynacmic-calc-up').css('color', 'red');
            $('#lc-dynacmic-calc-error-up').removeClass('lc-dynacmic-calc-error');
        }
    } else {
        $('#lc-dynacmic-calc-up').html('');
    }
}

/**
 * function to load the lye recommendation
 */
function loadLyeRecommendation() {
    var productAdded = [];
    var $elm = $('#lc-dynacmic-grid li');
    for (var i = 0; i < $elm.length; i++) {
        var $this = $($elm[i]);
        productAdded.push($this.find('#lc-dynacmic-grid-row #prodId').text());
    }

    if (productAdded.length > 0) {
        var loadRecommendationURL = $('.lye-calculator-wrapper').data(
            'recommendation-action'
        );
        $.ajax({
            url: loadRecommendationURL,
            type: 'POST',
            data: {
                productAdded: JSON.stringify(productAdded),
            },
            success: function (data) {
                $('.lye-calculator-recommendation-section').html(data);
            },
        });
    }
}

/**
 * Makes a call to the server to report the event of adding an item to the cart
 *
 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
 */
function miniCartReportingUrl(url) {
    if (url) {
        $.ajax({
            url: url,
            method: 'GET',
            success: function () {
                // reporting urls hit on the server
            },
            error: function () {
                // no reporting urls hit on the server
            },
        });
    }
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);

    if (response.error) {
        toastr.error(response.message);
    } else {
        toastr.success(response.message);
    }
}

// *********** Generic Functions **************

/**
 * calculate the lye calculation
 * @param {*} selectedType - type
 * @param {*} superFat - superFat value
 */
function calculateLyeTotal(selectedType, superFat) {
    var req = JSON.stringify(selectedProdVal);
    var url = util.appendParamsToUrl(
        Urls.calculateLyeTotal,
        {
            selectedProducts: req,
            type: selectedType,
            superFat: superFat,
        },
        true
    );
    ajax.getJson({
        url: url,
        async: false,
        callback: function (data) {
            if (data) {
                // eslint-disable-next-line no-undef
                // totalLyeSolid = data.totalLyeSolid;
                // eslint-disable-next-line no-undef
                // totalLyeLiquid = data.totalLyeLiquid;
                finalLyeTotal = data.finalLyeTotal;
                finalLyeLiquidTotal = data.finalLyeLiquidTotal;
            }
        },
    });
}

/**
 * fucntion to calculate the lye calculation
 * @param {*} fLT - fLT value
 * @param {*} fLLT - fLLT value
 * @param {*} iT - iT value
 * @param {*} isConvReq - isConvReq value
 * @param {*} selectedType - selectedType value
 * @param {*} aunitnew - selected unit
 */
function CalculateLye(fLT, fLLT, iT, isConvReq, selectedType, aunitnew) {
    // eslint-disable-line no-shadow
    var selectedUnit = $('#select-lc-step1-unit li.selected').attr('data-value');
    var iAmMaking = $('#select-lc-step1-type li.selected').attr('data-value');
    var bodylyeliquid = $('#lc-result-table-lye-liquid').find('tbody');
    var liquidImage = $('#lc-result-table-lye-liquid').data('liquid');
    var lyeImage = $('#lc-result-table-lye-liquid').data('lye');
    var sodiumLyeSku = $('#lc-result-table-lye-liquid').data('sodium-lye-sku');
    var potassiumLyeSku = $('#lc-result-table-lye-liquid').data(
        'potassium-lye-sku'
    );
    bodylyeliquid.html('');
    var quickViewUrl;
    var row1 = $('<tr class="alter-cell-color">');
    var $textalignLeft = $('<td class="textalign-left">');
    if (iAmMaking === 'Liquid Soap') {
        quickViewUrl = $('.lye-calculator-wrapper').data('quick-view-url');
        quickViewUrl += '?pid=' + potassiumLyeSku + '&source=quickview&lyeCal=true';
        row1.append(
            $textalignLeft.append(
                `<img class="dontPrint" width="50" height="50" src="${lyeImage}"/><div>Lye (Potassium Hydroxide)<br/><a toggle="modal" data-target="#quickViewModal" href="${quickViewUrl}" data-sku="${potassiumLyeSku}" class="add-btn quickview ${
                    potassiumLyeSku === '' ? 'd-none' : ''
                }" href="">ADD</a><div class="d-md-none mobileFLoater">${
                    fLT.toFixed(2) + aunitnew
                }</div></div>`
            )
        );
    } else {
        quickViewUrl = $('.lye-calculator-wrapper').data('quick-view-url');
        quickViewUrl += '?pid=' + sodiumLyeSku + '&source=quickview&lyeCal=true';
        row1.append(
            $textalignLeft.append(
                `<img class="dontPrint" width="50" height="50" src="${lyeImage}" /><div>Lye (Sodium Hydroxide)<br/><a toggle="modal" data-target="#quickViewModal" href="${quickViewUrl}" data-sku="${sodiumLyeSku}" class="add-btn quickview ${
                    sodiumLyeSku === '' ? 'd-none' : ''
                }" href="">ADD</a><div class="d-md-none mobileFloater">${
                    fLT.toFixed(2) + aunitnew
                }</div></div>`
            )
        );
    }
    row1.append($('<td>').append(fLT.toFixed(2) + aunitnew)); // Calculated Data
    bodylyeliquid.append(row1);

    var row2 = $('<tr>');
    var selectedUnitType =
		selectedUnit === 'Percentage' ? 'Amount' : selectedUnit;
    row2.append(
        $('<td class="textalign-left">').append(
            '<img class="dontPrint" width="50" height="50" src="' +
				liquidImage +
				'" /><div>' +
				selectedUnitType +
				' of liquid<div class="d-md-none mobileFloater">' +
				fLLT.toFixed(2) +
				aunitnew +
				'</div></div>'
        )
    );
    row2.append($('<td>').append(fLLT.toFixed(2) + aunitnew)); // Calculated Data
    bodylyeliquid.append(row2);

    var row3 = $('<tr class="alter-cell-color">');
    row3.append($('<td class="textalign-left bold">').append('Total'));
    row3.append(
        $('<td class="bold">').append((fLT + fLLT).toFixed(2) + aunitnew)
    ); // Calculated Data
    bodylyeliquid.append(row3);

    var bodyfats = $('#lc-result-table-oil-fats').find('tbody');
    bodyfats.html('');

    var itemTotalPerc = 0;
    var row;
    for (var mindex = 0; mindex <= selectedProdVal.length; mindex++) {
        var iclass = '';
        if (mindex % 2 !== 0) {
            iclass = 'class="alter-cell-color"';
        }
        if (mindex !== selectedProdVal.length) {
            var data = selectedProdVal[mindex];
            row = $('<tr ' + iclass + '>');

            var unitTd;
            if (isConvReq) {
                unitTd = (parseFloat(data.Qty) * 28.3495231).toFixed(2) + aunitnew;
                // row.append(
                //     $('<td>').append(
                //         (parseFloat(data.Qty) * 28.3495231).toFixed(2) + aunit
                //     )
                // );
            } else {
                unitTd = parseFloat(data.Qty).toFixed(2) + aunitnew;
                // row.append($('<td>').append(parseFloat(data.Qty).toFixed(2) + aunit));
            }

            var prodPerc = (parseFloat(data.Qty) * 100) / itemTotal;
            data.Percentage = prodPerc;
            itemTotalPerc += prodPerc;

            quickViewUrl = $('.lye-calculator-wrapper').data('quick-view-url');
            quickViewUrl += '?pid=' + data.ProdId + '&source=quickview&lyeCal=true';
            row.append(
                $('<td class="textalign-left">').append(
                    `<img class="dontPrint" width="50" height="50" src="${
                        data.productImage
                    }" /><div>${
                        data.ProductName
                    }<br/><a toggle="modal" data-target="#quickViewModal" href="${quickViewUrl}" class="quickview add-btn ${
                        data.productOrderable === 'true' ? '' : 'd-none'
                    }" data-sku="${
                        data.ProdId
                    }" href="">ADD</a><div class="d-md-none mobileFloater"><span>${unitTd}</span><span>${
                        prodPerc.toFixed(2) + '%'
                    }</span></div></div>`
                )
            );
            row.append($('<td>').append(unitTd));
            row.append($('<td>').append(prodPerc.toFixed(2) + '%'));
            bodyfats.append(row);
        } else {
            row = $('<tr ' + iclass + '>');
            row.append($('<td class="textalign-left bold">').append('Total'));
            row.append(
                $('<td class="bold">').append(parseFloat(iT).toFixed(2) + aunitnew)
            );
            row.append(
                $('<td class="bold">').append(itemTotalPerc.toFixed(2) + ' %')
            );
            bodyfats.append(row);
        }
    }

    var bodytotals = $('#lc-result-table-totals').find('tbody');
    bodytotals.html('');

    var row4 = $('<tr class="alter-cell-color">');
    row4.append($('<td class="textalign-left">').append('Lye & Liquid'));
    row4.append($('<td>').append((fLT + fLLT).toFixed(2) + aunitnew));
    bodytotals.append(row4);

    var row5 = $('<tr>');
    row5.append($('<td class="textalign-left">').append('Oils & Fats'));
    row5.append($('<td>').append(parseFloat(iT).toFixed(2) + aunitnew));
    bodytotals.append(row5);

    var row6 = $('<tr class="alter-cell-color">');
    row6.append($('<td class="textalign-left bold">').append('Total'));
    row6.append(
        $('<td class="bold">').append((fLT + fLLT + iT).toFixed(2) + aunitnew)
    );
    bodytotals.append(row6);
}

/**
 * populates the final label
 * @param {*} unit - unit value
 */
function PopulateFinalLabel(unit) {
    var selectedType = $('#select-lc-step1-type li.selected').attr('data-value');
    var superFat = $('#select-lc-step1-sl option:selected').val();
    var selectedUnit = $('#select-lc-step1-unit li.selected').attr('data-value');
    if (unit !== undefined && unit !== ' ') {
        selectedUnit = unit;
    }
    var stepFinalLabel =
		'A <strong>' +
		selectedType +
		'</strong> Soap with <strong>' +
		superFat +
		'%</strong> Superfat';
    $('.lc-stepfinal-label').html(stepFinalLabel);
}

/**
 * function to print the recipe
 */
function printRecipe() {
    $('.lc-print-status').show();
    var printWindow = window.open('', 'PrintWindow');
    $('.purplebox-print').css('display', 'block');
    $('.purplebox-print-image')
        .css('background-size', 'contain')
        .css('background-position', 'center center');
    $('.scent-section-small').css('width', '30%');
    $('.ounces-section-small').css('width', '15%');
    $('.grams-section-small').css('width', '15%');
    $('.lye_liq_head').addClass('startPrint');
    $('.dontPrint').css('display', 'none');
    $('.add-btn').css('display', 'none');
    $('.meausrement-changer-tab').css('display', 'none');
    $('.lye_liq_head').addClass('startPrint');
    $('.heading-label').addClass('startPrint');
    $('.lc-stepfinal-result table thead').addClass('startPrint');
    $('#printable').addClass('printThis');

    // Ensure the element is fully loaded and visible
    setTimeout(function () {
        var printableElement = document.getElementById('printable');

        // Check if the element has non-zero dimensions
        if (printableElement.offsetWidth > 0 && printableElement.offsetHeight > 0) {
            // eslint-disable-next-line no-undef
            html2canvas(printableElement)
                .then(function (canvas) {
                    var doc = printWindow.document;
                    var img = doc.createElement('img');
                    img.src = canvas.toDataURL('image/png');
                    doc.body.appendChild(img);
                    setTimeout(function () {
                        printWindow.print();
                        printWindow.close();
                        $('.purplebox-print').css('display', 'none');
                        $('.scent-section-small').css('width', 'inherit');
                        $('.ounces-section-small').css('width', 'inherit');
                        $('.grams-section-small').css('width', 'inherit');
                        $('.lc-print-status').hide();
                        $('.dontPrint').css('display', 'block');
                        $('.add-btn').css('display', 'inline-block');
                        $('.meausrement-changer-tab').css('display', 'flex');
                        $('.lye_liq_head').removeClass('startPrint');
                        $('.heading-label').removeClass('startPrint');
                        $('.lc-stepfinal-result table thead').removeClass('startPrint');
                        $('#printable').removeClass('printThis');
                    }, 10);
                })
                .catch(function (error) {
                    // console.error('Error capturing canvas:', error);
                    $('.purplebox-print').css('display', 'none');
                    $('.scent-section-small').css('width', 'inherit');
                    $('.ounces-section-small').css('width', 'inherit');
                    $('.grams-section-small').css('width', 'inherit');
                    $('.lc-print-status').hide();
                    $('.dontPrint').css('display', 'block');
                    $('.add-btn').css('display', 'inline-block');
                    $('.meausrement-changer-tab').css('display', 'flex');
                    $('.heading-label').removeClass('startPrint');
                    $('.lc-stepfinal-result table thead').removeClass('startPrint');
                    $('#printable').removeClass('printThis');
                });
        } else {
            // console.error('Printable element has zero width or height.');
            $('.purplebox-print').css('display', 'none');
            $('.scent-section-small').css('width', 'inherit');
            $('.ounces-section-small').css('width', 'inherit');
            $('.grams-section-small').css('width', 'inherit');
            $('.lc-print-status').hide();
            $('.dontPrint').css('display', 'block');
            $('.add-btn').css('display', 'inline-block');
            $('.meausrement-changer-tab').css('display', 'flex');
            $('.lye_liq_head').removeClass('startPrint');
            $('.heading-label').removeClass('startPrint');
            $('.lc-stepfinal-result table thead').removeClass('startPrint');
            $('#printable').removeClass('printThis');
        }
    }, 100); // Adjust the delay as needed
}

/**
 * function to print the recipe
 */
function printFragrance() {
    $('.lc-print-status').show();
    var printWindow = window.open('', 'PrintWindow');
    $('.purplebox-print').css('display', 'block');
    $('.purplebox-print-image')
        .css('background-size', 'contain')
        .css('background-position', 'center center');
    $('.scent-section-small').css('width', '30%');
    $('.ounces-section-small').css('width', '15%');
    $('.grams-section-small').css('width', '15%');
    $('.dontPrint').css('display', 'none');
    $('.add-btn').css('display', 'none');
    $('.fc-meausrement-changer-tab').css('display', 'none');
    $('.lye_liq_head').addClass('startPrint');
    $('.heading-label').addClass('startPrint');
    $('.fc-stepfinal-result table thead').addClass('startPrint');
    $('.js-fc-stepfinal-result').hide();
    $('#printable').addClass('printThis');
    $('.valueToShow').css('display', 'table-cell');
    $('#printable').css('width', '100%');
    $('.lye-calculator-step-cta').css('display', 'none');
    $('.heading-label-small').css('display', 'block');
    $('.fc-step2-label').css('justify-content', 'center');
    $('#fc-result-table-product-add').css('display', 'none');

    // Ensure the element is fully loaded and visible
    setTimeout(function () {
        var printableElement = document.getElementById('printable');
        // Set custom width for the output
        var desiredWidth = 600; // Desired width of the output image
        var scale = desiredWidth / printableElement.offsetWidth; // Calculate scale factor
        // Check if the element has non-zero dimensions
        if (printableElement.offsetWidth > 0 && printableElement.offsetHeight > 0) {
            // eslint-disable-next-line no-undef
            html2canvas(printableElement, {
                scale: scale, // Adjust the scale factor
                width: printableElement.offsetWidth * scale, // Custom width for the canvas
                height: printableElement.offsetHeight * scale, // Adjust the height proportionally
                windowWidth: '600px',
            })
                .then(function (canvas) {
                    var doc = printWindow.document;
                    var img = doc.createElement('img');
                    img.src = canvas.toDataURL('image/png');
                    doc.body.appendChild(img);
                    setTimeout(function () {
                        printWindow.print();
                        printWindow.close();
                        $('.purplebox-print').css('display', 'none');
                        $('.scent-section-small').css('width', 'inherit');
                        $('.ounces-section-small').css('width', 'inherit');
                        $('.grams-section-small').css('width', 'inherit');
                        $('.lc-print-status').hide();
                        $('.dontPrint').css('display', 'block');
                        $('.add-btn').css('display', 'inline-block');
                        $('.fc-meausrement-changer-tab').css('display', 'flex');
                        $('.lye_liq_head').removeClass('startPrint');
                        $('.heading-label').removeClass('startPrint');
                        $('.fc-stepfinal-result table thead').removeClass('startPrint');
                        $('#printable').removeClass('printThis');
                        $('.js-fc-stepfinal-result').show();
                        $('.valueToShow:not(.show)').css('display', 'none');
                        $('.lye-calculator-step-cta').css('display', 'block');
                        $('.heading-label-small').css('display', 'none');
                        $('.fc-step2-label').css('justify-content', 'flex-start');
                        $('#fc-result-table-product-add').css('display', 'table');
                    }, 10);
                })
                .catch(function (error) {
                    // console.error('Error capturing canvas:', error);
                    $('.purplebox-print').css('display', 'none');
                    $('.scent-section-small').css('width', 'inherit');
                    $('.ounces-section-small').css('width', 'inherit');
                    $('.grams-section-small').css('width', 'inherit');
                    $('.lc-print-status').hide();
                    $('.dontPrint').css('display', 'block');
                    $('.add-btn').css('display', 'inline-block');
                    $('.fc-meausrement-changer-tab').css('display', 'flex');
                    $('.lye_liq_head').removeClass('startPrint');
                    $('.heading-label').removeClass('startPrint');
                    $('.fc-stepfinal-result table thead').removeClass('startPrint');
                    $('#printable').removeClass('printThis');
                    $('.js-fc-stepfinal-result').show();
                    $('.valueToShow:not(.show)').css('display', 'none');
                    $('.lye-calculator-step-cta').css('display', 'block');
                    $('.heading-label-small').css('display', 'none');
                    '.fc-step2-label'.css('justify-content', 'flex-start');
                    $('#fc-result-table-product-add').css('display', 'table');
                });
        } else {
            // console.error('Printable element has zero width or height.');
            $('.purplebox-print').css('display', 'none');
            $('.scent-section-small').css('width', 'inherit');
            $('.ounces-section-small').css('width', 'inherit');
            $('.grams-section-small').css('width', 'inherit');
            $('.lc-print-status').hide();
            $('.dontPrint').css('display', 'block');
            $('.add-btn').css('display', 'inline-block');
            $('.fc-meausrement-changer-tab').css('display', 'flex');
            $('.lye_liq_head').removeClass('startPrint');
            $('.heading-label').removeClass('startPrint');
            $('.fc-stepfinal-result table thead').removeClass('startPrint');
            $('#printable').removeClass('printThis');
            $('.js-fc-stepfinal-result').show();
            $('.valueToShow:not(.show)').css('display', 'none');
            $('.lye-calculator-step-cta').css('display', 'block');
            $('.heading-label-small').css('display', 'none');
            '.fc-step2-label'.css('justify-content', 'flex-start');
            $('#fc-result-table-product-add').css('display', 'table');
        }
    }, 100); // Adjust the delay as needed
}

/**
 * escapes the special characters in the string
 * @param {*} string - text
 * @returns {string} text
 */
function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * replaces all occurrences of a term in a string
 * @param {*} str - string
 * @param {*} term - replacement term
 * @param {*} replacement - replacement value
 * @returns {string} text
 */
function replaceAll(str, term, replacement) {
    return str.replace(new RegExp(escapeRegExp(term), 'g'), replacement);
}

// /**
//  * function calcualte grame value
//  * @param {*} amount - amount value
//  * @param {*} prodPerc - precentage value
//  * @returns {number} grame value
//  */
// function calculateGram(amount, prodPerc) {
//     return (parseFloat(amount) / 100) * parseFloat(prodPerc);
// }

// /**
//  * fetches the product list from the database and populates the table with the product list data
//  * @param {string} calcType - calculation type
//  * @returns {Object} data
//  */
// function getProductList(calcType) {
//     var resData;
//     var url = util.appendParamsToUrl(
//         Urls.calcInProductList,
//         {
//             calcType: 'fragrance',
//         },
//         true
//     );
//     ajax.getJson({
//         url: url,
//         async: false,
//         // eslint-disable-next-line consistent-return
//         callback: function (data) {
//             if (!data) {
//                 // eslint-disable-next-line no-alert
//                 window.alert("Couldn't find products.");
//                 return null;
//             }

//             var $fcstep1 = $('#tb-fc-step1');
//             progress.show($fcstep1);
//             resData = data;
//             progress.hide();
//             tooltips.init();
//         },
//     });

//     return resData;
// }

/**
 * populate the product list with products in lye calculation
 * @returns {Object} data
 */
function populateLye() {
    var lyeAndLiquid = [];
    var oilAndFats = [];
    var totals = [];
    var isHeaderIgnored = false;
    $('#lc-result-table-lye-liquid')
        .find('tr')
        .each(function () {
            var lyeTr = [];
            if (isHeaderIgnored) {
                $(this)
                    .find('td')
                    .each(function () {
                        lyeTr.push($(this).html());
                    });
                lyeAndLiquid.push(lyeTr);
            } else {
                isHeaderIgnored = true;
            }
        });

    isHeaderIgnored = false;
    $('#lc-result-table-oil-fats')
        .find('tr')
        .each(function () {
            var lyeTr = [];
            if (isHeaderIgnored) {
                $(this)
                    .find('td')
                    .each(function () {
                        lyeTr.push($(this).html());
                    });
                oilAndFats.push(lyeTr);
            } else {
                isHeaderIgnored = true;
            }
        });

    isHeaderIgnored = false;
    $('#lc-result-table-totals')
        .find('tr')
        .each(function () {
            var lyeTr = [];
            if (isHeaderIgnored) {
                $(this)
                    .find('td')
                    .each(function () {
                        var theString = $(this).html();
                        var varTitle = $('<textarea />').html(theString).text();
                        lyeTr.push(varTitle);
                    });
                totals.push(lyeTr);
            } else {
                isHeaderIgnored = true;
            }
        });

    var today = new Date();
    var id =
		today.getFullYear().toString() +
		(today.getMonth() + 1) +
		today.getDate().toString() +
		today.getHours() +
		today.getMinutes() +
		today.getSeconds();
    var crDate =
		(today.getMonth() + 1).toString() +
		'/' +
		today.getDate().toString() +
		'/' +
		today.getFullYear();
    var name = $('.lc-stepfinal-label').html();
    name = replaceAll(name, '</strong>', '');
    name = replaceAll(name, '<strong>', '');
    var recipe = {
        RecipeId: id,
        RecipeName: name,
        RecipeTitle: $('#tb-lc-stepfinal-rt').val(),
        RecipeNote: $('#tb-lc-stepfinal-rn').val(),
        CreatedDate: crDate,
        Recipe: {
            LyeAndLiquid: lyeAndLiquid,
            OilAndFats: oilAndFats,
            Totals: totals,
        },
    };
    return recipe;
}

/**
 * function fetches the product detail data from the database and populates the table with the product detail data
 * @param {*} productId - product ID
 * @returns {Object} data
 */
function getProductDetail(productId) {
    var resData;
    var url = util.appendParamsToUrl(
        Urls.calcGetProductDetail,
        {
            productId: productId,
        },
        true
    );
    ajax.getJson({
        url: url,
        async: false,
        callback: function (data) {
            if (!data) {
                // eslint-disable-next-line no-alert
                window.alert("Couldn't find product.");
            }

            var $fcstep1 = $('#tb-fc-step1');
            progress.show($fcstep1);
            resData = data;
            progress.hide();
            // tooltips.init();
        },
    });

    return resData;
}

/**
 * get the maker category mapping
 * @param {*} makerCat - category
 * @param {*} selectedProductId1 - the product ID
 * @param {*} selectedUnit - unit
 * @param {*} selectedAmount - amount
 * @returns {Object} mappaing
 */
function getMapping(
    makerCat,
    selectedProductId1,
    selectedUnit,
    selectedAmount
) {
    var mapping = null;
    var url = util.appendParamsToUrl(
        Urls.calcGetMapping,
        {
            makerCat: makerCat,
            productId: selectedProductId1,
            unit: selectedUnit,
            amount: selectedAmount,
        },
        true
    );
    ajax.getJson({
        url: url,
        async: false,
        callback: function (data) {
            if (!data) {
                // eslint-disable-next-line no-alert
                window.alert(
                    "Couldn't find maker category " +
						makerCat +
						' mapping data in site preference.'
                );
            }
            mapping = data;
        },
    });

    if (typeof mapping.message !== 'undefined' && mapping.message !== null) {
        // eslint-disable-next-line no-alert
        window.alert(mapping.message);
    }

    return mapping;
}

/**
 * populates the fragrance recipe
 * @returns {Object} recipe object
 */
function populateFragrance() {
    var results = [];
    var isHeaderIgnored = false;
    $('#fc-result-table')
        .find('tr')
        .each(function () {
            var lyeTr = [];
            if (isHeaderIgnored) {
                $(this)
                    .find('td')
                    .each(function () {
                        lyeTr.push($(this).html());
                    });
                results.push(lyeTr);
            } else {
                isHeaderIgnored = true;
            }
        });

    var today = new Date();
    var id =
		today.getFullYear().toString() +
		(today.getMonth() + 1) +
		today.getDate().toString() +
		today.getHours() +
		today.getMinutes() +
		today.getSeconds();
    var crDate =
		(today.getMonth() + 1).toString() +
		'/' +
		today.getDate().toString() +
		'/' +
		today.getFullYear();
    var recipe = {
        RecipeId: id,
        RecipeName: 'Fragrance Recipe',
        RecipeTitle: $('<textarea />').html(selectedProductName).text(),
        RecipeNote: '',
        CreatedDate: crDate,
        Recipe: {
            ProductId: selectedProductId,
            MakerCat: $('#tb-fc-step2-cat option:selected').val(),
            Amount: $('#tb-fc-step2-amt').val(),
            Unit: $('#tb-fc-step2-unit option:selected').val(),
            Results: results,
        },
    };
    return recipe;
}

/**
 * fucntion to save the reciepe
 * @param {*} recipe - recipe object
 * @param {*} calcType - calculation type
 * @returns {Object} response
 */
function saveRecipe(recipe, calcType) {
    var response = null;
    var req = JSON.stringify(recipe);
    var url = util.appendParamsToUrl(
        Urls.calcSaveRecipe,
        {
            recipe: req,
            calcType: calcType,
        },
        true
    );
    ajax.getJson({
        url: url,
        async: false,
        callback: function (data) {
            if (data) {
                response = data;
            }
        },
    });

    $('.divider i').removeClass('fal fa-heart');
    $('.divider i').addClass('fas fa-heart dark-rose');
    return response;
}

/**
 * fucntion to calculate the fragrance calculation
 * @param {*} unit - fLT value
 * @returns {Object} response
 */
function CalculateFragrance(unit) {
    var row;
    var selectedCat = $('.js-seelcted-product-info')
        .find('#prodId')
        .text()
        .trim();
    var body = $('#fc-result-table').find('tbody');
    var body2 = $('#fc-result-table-totals').find('tbody');
    body.html('');
    body2.html('');
    selectedProductId = $('.js-seelcted-oil-info').find('#prodId').text().trim();
    var selectedProductImage = $('.js-seelcted-oil-info').find('img').attr('src');
    var selectedProductNameFrag = $('.js-seelcted-oil-info')
        .find('#prodName')
        .text()
        .trim();
    var selectedUnit = unit; // Unit for Calculation

    $('.js-final-product-image').attr('src', selectedProductImage);
    $('.js-final-product-name').text(selectedProductNameFrag);
    var quickViewUrl = $('.js-final-product-sku').attr('href');
    quickViewUrl =
		quickViewUrl +
		'?pid=' +
		selectedProductId +
		'&source=quickview&fragCal=true';
    $('.js-final-product-sku').attr('href', quickViewUrl);

    var selectedAmount = $('#tb-fc-step2-amt').val(); // Amount

    var mapping = getMapping(
        selectedCat,
        selectedProductId,
        selectedUnit,
        selectedAmount
    );

    $('.frag-calculator-wrapper').attr(
        'data-result',
        JSON.stringify(mapping.data)
    );

    $('.fc-step2-cat').html(selectedCat);
    $('.fc-step2-amt').html(
        selectedAmount +
			'' +
			(selectedUnit === 'Ounces'
			    ? 'oz'
			    : selectedUnit === 'Grams'
			        ? 'g'
			        : selectedUnit)
    );

    var IFRARate = 0;
    var bottomValues = 0;
    for (var mindex = 0; mindex < mapping.data.length; mindex++) {
        var values = mapping.data[mindex]; // e.g. [0: "IFRA Maximum usage: Category 7A",1: "0.00", 2: "0.02", 3: 0.82]
        var iclass = '';
        if (mindex === 0) {
            // IFRA percentage value
            IFRARate = values[3];
        }

        if (mindex < 4) {
            // Compare with light, medium and strong percentage values

            if (IFRARate && values[3] > IFRARate) {
                iclass = 'class="fc-row-pink"';
            }
            row = $('<tr ' + iclass + '>');
            row.append($('<td class="textalign-left">').append(values[0]));
            if (values[0].indexOf('IFRA') > -1) {
                if (values[1] === 'N/A') {
                    row.append($('<td class="ouncesShow valueToShow">').append('N/A'));
                } else {
                    row.append(
                        $('<td class="ouncesShow valueToShow">').append(
                            !values[1] || isNaN(values[1]) ? '' : values[1] + ' oz' // eslint-disable-next-line no-restricted-globals
                        )
                    );
                }
                if (values[2] === 'N/A') {
                    row.append($('<td class="gramShow valueToShow">').append('N/A'));
                } else {
                    row.append(
                        $('<td class="gramShow valueToShow">').append(
                            !values[2] || isNaN(values[2]) ? '' : values[2] + ' g' // eslint-disable-next-line no-restricted-globals
                        )
                    );
                }
                if (values[3] === 'N/A') {
                    row.append($('<td class="percentShow valueToShow">').append('N/A'));
                } else {
                    row.append(
                        $('<td class="percentShow valueToShow">').append(
                            !values[3] || isNaN(values[3]) ? '' : values[3] + '%' // eslint-disable-next-line no-restricted-globals
                        )
                    );
                }
            } else {
                row.append(
                    $('<td class="ouncesShow valueToShow">').append(
                        !values[1] || isNaN(values[1]) ? '' : values[1] + ' oz' // eslint-disable-next-line no-restricted-globals
                    )
                );
                row.append(
                    $('<td class="gramShow valueToShow">').append(
                        !values[2] || isNaN(values[2]) ? '' : values[2] + ' g' // eslint-disable-next-line no-restricted-globals
                    )
                );
                row.append(
                    $('<td class="percentShow valueToShow">').append(
                        !values[3] || isNaN(values[3]) ? '' : values[3] + '%' // eslint-disable-next-line no-restricted-globals
                    )
                );
            }
            body.append(row);
        } else if (values[0] !== 'ifracategory') {
            row = $('<tr ' + iclass + '>');
            row.append($('<td class="textalign-left">').append(values[0]));
            if (values[1] !== '' && values[1].indexOf('-no-unit') > -1) {
                row.append(
                    $('<td class="ouncesShow valueToShow">').append(
                        !values[1] ? '' : values[1].replace('-no-unit', '')
                    )
                );
            } else {
                row.append(
                    $('<td class="ouncesShow valueToShow">').append(
                        !values[1] ? '' : values[1] + ' oz'
                    )
                );
            }

            if (values[2] !== '' && values[2].indexOf('-no-unit') > -1) {
                row.append(
                    $('<td class="gramShow valueToShow">').append(
                        !values[2] ? '' : values[2].replace('-no-unit', '')
                    )
                );
            } else {
                row.append(
                    $('<td class="gramShow valueToShow">').append(
                        !values[2] ? '' : values[2] + ' g'
                    )
                );
            }

            if (values[3] !== '' && values[3].indexOf('-no-unit') > -1) {
                row.append(
                    $('<td class="percentShow valueToShow">').append(
                        !values[3] ? '' : values[3].replace('-no-unit', '')
                    )
                );
            } else {
                row.append(
                    $('<td class="percentShow valueToShow">').append(
                        !values[3] ? '' : values[3] + '%'
                    )
                );
            }
            body2.append(row);
            bottomValues += 1;
        }

        if (bottomValues > 0) {
            $('.js-fc-stepfinal-result').show();
        } else {
            $('.js-fc-stepfinal-result').hide();
        }
        // update add to cart button link
        // var url = util.appendParamsToUrl(
        //     Urls.getFragProductUrl,
        //     {
        //         pid: selectedProductId.trim(),
        //         source: 'quickview',
        //         fragCal: true,
        //     },
        //     true
        // );
        // $('#quickviewbutton').data('link', url);
        // $('#quickviewbutton').attr('href', url);

        if (selectedUnit === 'Ounces') {
            $('.fc-meausrement-changer-tab')
                .find('li a[data-value="Ounces"]')
                .parent()
                .addClass('active')
                .siblings()
                .removeClass('active');
            $('.valueToShow.ouncesShow').addClass('show');
        } else if (selectedUnit === 'Grams') {
            $('.fc-meausrement-changer-tab')
                .find('li a[data-value="Grams"]')
                .parent()
                .addClass('active')
                .siblings()
                .removeClass('active');
            $('.valueToShow.gramShow').addClass('show');
        } else {
            return false;
        }
    }
}

/**
 * fucntion to calculate the fragrance calculation
 * @param {*} unit - fLT value
 * @returns {Object} response
 */
function changeFragValues(unit) {
    var row;
    // var selectedCat = $('.js-seelcted-product-info')
    //     .find('#prodId')
    //     .text()
    //     .trim();
    var body = $('#fc-result-table').find('tbody');
    var body2 = $('#fc-result-table-totals').find('tbody');
    body.html('');
    body2.html('');
    // selectedProductId = $('.js-seelcted-oil-info').find('#prodId').text().trim();
    var selectedUnit = unit; // Unit for Calculation

    var selectedAmount = $('#tb-fc-step2-amt').val(); // Amount
    var primaryUNit = $('#select-fc-step1-unit')
        .find('li.selected')
        .attr('data-value');
    if (primaryUNit === 'Ounces' && unit === 'Grams') {
        selectedAmount *= 28.3495;
    } else if (primaryUNit === 'Grams' && unit === 'Ounces') {
        selectedAmount /= 28.3495;
    }

    var mapping = JSON.parse($('.frag-calculator-wrapper').attr('data-result'));

    // $('.fc-step2-cat').html(selectedCat);
    $('.fc-step2-amt').html(
        selectedAmount +
			'' +
			(selectedUnit === 'Ounces'
			    ? 'oz'
			    : selectedUnit === 'Grams'
			        ? 'g'
			        : selectedUnit)
    );

    var IFRARate = 0;
    var bottomValues = 0;
    for (var mindex = 0; mindex < mapping.length; mindex++) {
        var values = mapping[mindex]; // e.g. [0: "IFRA Maximum usage: Category 7A",1: "0.00", 2: "0.02", 3: 0.82]
        var iclass = '';
        if (mindex === 0) {
            // IFRA percentage value
            IFRARate = values[3];
        }

        if (mindex < 4) {
            // Compare with light, medium and strong percentage values

            if (IFRARate && values[3] > IFRARate) {
                iclass = 'class="fc-row-pink"';
            }
            row = $('<tr ' + iclass + '>');
            row.append($('<td class="textalign-left">').append(values[0]));
            if (values[0].indexOf('IFRA') > -1) {
                if (values[1] === 'N/A') {
                    row.append($('<td class="ouncesShow valueToShow">').append('N/A'));
                } else {
                    row.append(
                        $('<td class="ouncesShow valueToShow">').append(
                            !values[1] || isNaN(values[1]) ? '' : values[1] + ' oz' // eslint-disable-next-line no-restricted-globals
                        )
                    );
                }
                if (values[2] === 'N/A') {
                    row.append($('<td class="gramShow valueToShow">').append('N/A'));
                } else {
                    row.append(
                        $('<td class="gramShow valueToShow">').append(
                            !values[2] || isNaN(values[2]) ? '' : values[2] + ' g' // eslint-disable-next-line no-restricted-globals
                        )
                    );
                }
                if (values[3] === 'N/A') {
                    row.append($('<td class="percentShow valueToShow">').append('N/A'));
                } else {
                    row.append(
                        $('<td class="percentShow valueToShow">').append(
                            !values[3] || isNaN(values[3]) ? '' : values[3] + '%' // eslint-disable-next-line no-restricted-globals
                        )
                    );
                }
            } else {
                row.append(
                    $('<td class="ouncesShow valueToShow">').append(
                        !values[1] || isNaN(values[1]) ? '' : values[1] + ' oz' // eslint-disable-next-line no-restricted-globals
                    )
                );
                row.append(
                    $('<td class="gramShow valueToShow">').append(
                        !values[2] || isNaN(values[2]) ? '' : values[2] + ' g' // eslint-disable-next-line no-restricted-globals
                    )
                );
                row.append(
                    $('<td class="percentShow valueToShow">').append(
                        !values[3] || isNaN(values[3]) ? '' : values[3] + '%' // eslint-disable-next-line no-restricted-globals
                    )
                );
            }
            body.append(row);
        } else if (values[0] !== 'ifracategory') {
            row = $('<tr ' + iclass + '>');
            row.append($('<td class="textalign-left">').append(values[0]));

            if (values[1] !== '' && values[1].indexOf('-no-unit') > -1) {
                row.append(
                    $('<td class="ouncesShow valueToShow">').append(
                        !values[1] ? '' : values[1].replace('-no-unit', '')
                    )
                );
            } else {
                row.append(
                    $('<td class="ouncesShow valueToShow">').append(
                        !values[1] ? '' : values[1] + ' oz'
                    )
                );
            }

            if (values[2] !== '' && values[2].indexOf('-no-unit') > -1) {
                row.append(
                    $('<td class="gramShow valueToShow">').append(
                        !values[2] ? '' : values[2].replace('-no-unit', '')
                    )
                );
            } else {
                row.append(
                    $('<td class="gramShow valueToShow">').append(
                        !values[2] ? '' : values[2] + ' g'
                    )
                );
            }

            if (values[3] !== '' && values[3].indexOf('-no-unit') > -1) {
                row.append(
                    $('<td class="percentShow valueToShow">').append(
                        !values[3] ? '' : values[3].replace('-no-unit', '')
                    )
                );
            } else {
                row.append(
                    $('<td class="percentShow valueToShow">').append(
                        !values[3] ? '' : values[3] + '%'
                    )
                );
            }
            bottomValues += 1;
            body2.append(row);
        }

        if (bottomValues > 0) {
            $('.js-fc-stepfinal-result').show();
        } else {
            $('.js-fc-stepfinal-result').hide();
        }

        if (selectedUnit === 'Ounces') {
            $('.fc-meausrement-changer-tab')
                .find('li a[data-value="Ounces"]')
                .parent()
                .addClass('active')
                .siblings()
                .removeClass('active');
            $('.valueToShow.ouncesShow').addClass('show');
        } else if (selectedUnit === 'Grams') {
            $('.fc-meausrement-changer-tab')
                .find('li a[data-value="Grams"]')
                .parent()
                .addClass('active')
                .siblings()
                .removeClass('active');
            $('.valueToShow.gramShow').addClass('show');
        } else {
            return false;
        }
    }
}

module.exports = function () {
    var ns = 'calculator';
    if (ns !== null && ns === 'calculator') {
        // ******************** Fragrance Calculator *********************

        var productList = [];
        var cindex;
        // Binding all products to search box
        // var tempList = $('.fc-product-list-hidden');
        // for (cindex = 0; cindex < tempList.length; cindex++) {
        //     if (tempList[cindex].innerHTML === '') break;
        //     var splitData = tempList[cindex].innerHTML.split('|');
        //     productList.push({ Id: splitData[0], Name: splitData[1] });
        // }
        // // Search products and bind to search list with key press event
        // $('#tb-fc-step1').on('keyup', function (e) {
        //     var searchData = productList.filter(function (d) {
        //         return d.Name.toLowerCase().match(e.target.value.trim().toLowerCase());
        //     });
        //     var searchHtml = '';
        //     if (searchData.length === 0 || !e.target.value.trim()) {
        //         $('.fc-product-list').hide();
        //         return;
        //     }
        //     // eslint-disable-next-line array-callback-return
        //     searchData.map(function (s) {
        //         searchHtml += '<li>' + s.Name + '</li>';
        //     });
        //     $('.fc-product-list').html(searchHtml).show();
        //     $('#tb-fc-step1').css('border-color', '').css('color', '');
        // });

        // // Fire events on selected from searched product list
        // $('.fc-product-list').on('click touchstart', 'li', function (e) {
        //     selectedProductName = $(this).html();
        //     if (selectedProductName !== null) {
        //         for (cindex = 0; cindex < productList.length; cindex++) {
        //             if (productList[cindex].Name === selectedProductName) {
        //                 selectedProductId = productList[cindex].Id;
        //                 break;
        //             }
        //         }
        //         $('#tb-fc-step1').val(
        //             $('<textarea />').html(selectedProductName).text()
        //         );
        //     }
        //     $(this)
        //         .css('background-color', '#B84B65 !important')
        //         .css('color', '#ccc !important');
        //     $('.fc-product-list').hide();
        //     // BBFC-670 disable frag oil auto submit for mobile
        //     var mobile = /iphone|ipod|android|blackberry|mini|windows\sce|palm/i.test(
        //         navigator.userAgent.toLowerCase()
        //     );
        //     if (mobile) {
        //         e.preventDefault();
        //     }
        // });

        // Step 2 Button click event
        // eslint-disable-next-line consistent-return
        $('#btn-fc-step2').click(function () {
            var row;
            var selectedOilDom = $('.js-seelcted-oil-info').text(); // Maker Category
            if (selectedOilDom === '') {
                toastr.error('Please select which fragrance oil you are using.');
                // $('#tb-fc-step2-cat').focus();
                // $('.js-open-product-search-oil-flyout').css('border-color', 'red').css('color', 'red');
                return false;
            }
            // selectedProductId = $('.js-seelcted-oil-info')
            //     .find('#prodId')
            //     .text()
            //     .trim();

            var selectedMakerCatrgoryDom = $('.js-seelcted-product-info').text(); // Maker Category
            if (selectedMakerCatrgoryDom === '') {
                toastr.error('Please select what you are making.');
                // $('#tb-fc-step2-cat').focus();
                // $('.js-open-product-search-product-flyout').css('border-color', 'red').css('color', 'red');
                return false;
            }

            // var selectedCat = $('.js-seelcted-product-info')
            //     .find('#prodId')
            //     .text()
            //     .trim();

            var selectedAmount = $('#tb-fc-step2-amt').val(); // Amount
            if (
                selectedAmount === null ||
				selectedAmount === '' ||
				Number.isNaN(selectedAmount) ||
				selectedAmount < 0
            ) {
                toastr.error('Please enter a valid amount.');
                return false;
            }

            if ($('#select-fc-step1-unit li.selected').length === 0) {
                toastr.error('Please select a unit.');
                return false;
            }
            var selectedUnit = $('#select-fc-step1-unit li.selected').attr(
                'data-value'
            ); // Unit for Calculation

            // var mapping = getMapping(
            //     selectedCat,
            //     selectedProductId,
            //     selectedUnit,
            //     selectedAmount
            // );
            // if (
            //     mapping !== null &&
            // 	mapping.data !== null &&
            // 	mapping.data.length > 0
            // ) {
            $('.tab-pane.step1-content').removeClass('active');
            $('.tab-pane.step2-content').addClass('active');
            // $('.fc-step2-cat').html(selectedCat);
            // $('.fc-step2-amt').html(selectedAmount + '' + (selectedUnit === 'Ounces' ? 'oz' : selectedUnit === 'Grams' ? 'g': selectedUnit));
            $('.fc-stepfinal-default').css('display', 'block');
            $('.greybox-productname').css('display', 'none');
            CalculateFragrance(selectedUnit);
            //         var body = $('#fc-result-table').find('tbody');
            //         var body2 = $('#fc-result-table-totals').find('tbody');
            //         body.html('');
            //         body2.html('');
            //         var IFRARate = 0;
            //         for (var mindex = 0; mindex < mapping.data.length; mindex++) {
            //             var values = mapping.data[mindex]; // e.g. [0: "IFRA Maximum usage: Category 7A",1: "0.00", 2: "0.02", 3: 0.82]
            //             var iclass = '';
            //             if (mindex === 0) {
            //                 // IFRA percentage value
            //                 IFRARate = values[3];
            //             }

            //             /* if (mindex % 2 !== 0) {
            //     iclass = 'class="fc-row-pink"';
            //   } */
            //             if (mindex < 4) {
            //                 // Compare with light, medium and strong percentage values
            //                 if (IFRARate && values[3] > IFRARate) {
            //                     iclass = 'class="fc-row-pink"';
            //                 }
            //                 row = $('<tr ' + iclass + '>');
            //                 row.append(
            //                     $('<td class="textalign-left">').append(
            //                         values[0]
            //                     )
            //                 );
            //                 row.append(
            //                     $('<td class="ouncesShow valueToShow">').append(
            //                         Number.isNaN(values[1]) ? 'N/A' : values[1] + ' oz'
            //                     )
            //                 );
            //                 row.append(
            //                     $('<td class="gramShow valueToShow">').append(
            //                         Number.isNaN(values[2]) ? 'N/A' : values[2] + ' g'
            //                     )
            //                 );
            //                 // row.append(
            //                 //     $('<td class="percentShow valueToShow">').append(
            //                 //         !values[3] || Number.isNaN(values[3]) ? 'N/A' : values[3] + '%'
            //                 //     )
            //                 // );
            //                 body.append(row);
            //             } else {
            //                 row = $('<tr ' + iclass + '>');
            //                 row.append($('<td class="textalign-left">').append(values[0]));
            //                 row.append($('<td class="ouncesShow valueToShow">').append(!values[1] ? '' : values[1] + ' oz'));
            //                 row.append($('<td class="gramShow valueToShow">').append(!values[2] ? '' : values[2] + ' g'));
            //                 // row.append($('<td class="percentShow valueToShow">').append(!values[3] ? '' : values[3] + '%'));
            //                 body2.append(row);
            //             }
            //             // update add to cart button link
            //             var url = util.appendParamsToUrl(
            //                 Urls.getFragProductUrl,
            //                 {
            //                     pid: selectedProductId.trim(),
            //                     source: 'quickview',
            //                     fragCal: true,
            //                 },
            //                 true
            //             );
            //             // $('#quickviewbutton').data('link', url);
            //             $('#quickviewbutton').attr('href', url);

            //             if (selectedUnit === 'Ounces') {
            //                 aunit = 'Ounces';
            //                 $('.fc-meausrement-changer-tab')
            //                     .find('li a[data-value="Ounces"]')
            //                     .parent()
            //                     .addClass('active')
            //                     .siblings()
            //                     .removeClass('active');
            //                     $('.valueToShow.ouncesShow').addClass('show');
            //             } else if (selectedUnit === 'Grams') {
            //                 aunit = 'Grams';
            //                 $('.fc-meausrement-changer-tab')
            //                     .find('li a[data-value="Grams"]')
            //                     .parent()
            //                     .addClass('active')
            //                     .siblings()
            //                     .removeClass('active');
            //                     $('.valueToShow.gramShow').addClass('show');
            //             } else {
            //                 return false;
            //             }
            //         }
            // } else {
            //     return false;
            // }
        });

        $('body').on(
            'click',
            '.fc-meausrement-changer-tab li:not(.active) a',
            function () {
                var $this = $(this);
                var selectedType = $this.data('value');
                // var $title = $('.fc-step2-amt').html().replace(/\D/g, '');
                $this.parent().addClass('active').siblings().removeClass('active');
                changeFragValues(selectedType);
            }
        );
        // // Maker category change event
        // $('#tb-fc-step2-cat').on('change', function () {
        //     var selectedCat = $('#tb-fc-step2-cat option:selected').val();
        //     if (selectedCat === '-1') {
        //         $('#tb-fc-step2-cat').focus();
        //         $('#tb-fc-step2-cat').css('border-color', 'red').css('color', 'red');
        //     } else {
        //         $('#tb-fc-step2-cat').css('border-color', '').css('color', '');
        //     }
        // });
        // // Amount text box data change event
        // // eslint-disable-next-line consistent-return
        // $('#tb-fc-step2-amt').change(function () {
        //     var selectedAmount = $('#tb-fc-step2-amt').val();
        //     if (
        //         selectedAmount === null ||
        // 		selectedAmount === '' ||
        // 		Number.isNaN(selectedAmount)
        //     ) {
        //         $('#tb-fc-step2-amt').focus();
        //         $('#tb-fc-step2-amt').css('border-color', 'red').css('color', 'red');
        //         return false;
        //     }
        //     $('#tb-fc-step2-amt').css('border-color', '').css('color', '');
        // });
        // Amount div data change event
        // $('#div-fc-amt').click(function () {
        //     $('.tb-fc-step2-amt').change();
        // });
        // // Step2 unit selected data change event
        // $('#tb-fc-step2-unit').on('change', function () {
        //     var selectedUnit = $('#tb-fc-step2-unit option:selected').val();
        //     if (selectedUnit === '-1') {
        //         $('#tb-fc-step2-unit').focus();
        //         $('#tb-fc-step2-unit').css('border-color', 'red').css('color', 'red');
        //     } else {
        //         $('#tb-fc-step2-unit').css('border-color', '').css('color', '');
        //     }
        // });
        // Step1 edit link click event
        // $('.fc-step1-edit').click(function (e) {
        //     $('.fc-step1-default').css('display', 'block');
        //     // BBFC-670 move focus to step1 upon edit
        //     e.preventDefault();
        //     $('.fc-step1-default').focus();

        //     $('.fc-step1-label').css('display', 'none');
        //     $('.fc-step2-fieldset').css('display', 'none');
        //     $('.fc-stepfinal-fieldset').css('display', 'none');
        // });
        // Step2 edit link click event
        // $('#fc-step2-edit').click(function (e) {
        //     $('.fc-step2-default').css('display', 'block');
        //     // BBFC-670 move focus to step2 upon edit
        //     e.preventDefault();
        //     $('.fc-step2-default').focus();

        //     $('.fc-step2-label').css('display', 'none');
        //     $('.fc-stepfinal-fieldset').css('display', 'none');
        //     $('.greybox-productname').css('display', 'block');
        // });
        // // Step final button buy oil click event
        // $('#btn-fc-stepfinal-buyoil').click(function () {
        //     $('#btn-fc-stepfinal-buyoil').attr('value', selectedProductId);
        // });
        // // Step final add to favorite button click event
        $('#fc-stepfinal-add').click(function () {
            var recipe = populateFragrance();
            var respose = saveRecipe(recipe, 'fragrance');
            if (respose !== null) {
                if (respose.Message !== undefined) {
                    if (respose.IsSuccess) {
                        toastr.success(respose.Message);
                        // $('#save-response').html(respose.Message).css('color', 'green');
                    } else {
                        toastr.error(respose.Message);
                        // $('#save-response').html(respose.Message).css('color', 'red');
                    }
                }
            }
            $('#recipeAddModal').find('.modal-close').trigger('click');
        });

        $('#fc-stepfinal-print').click(function () {
            printFragrance();
            return false;
        });
        // Step2 print button click event
        $('#fc-step2-print').click(function () {
            printRecipe();
            return false;
        });

        $('body').on('click', '#fc-dynacmic-grid-flyout li', function () {
            var $parent = $(this).parents('#fc-dynacmic-grid-flyout');
            var $html = $(this).find('#fc-dynacmic-grid-row-flyout').clone();
            if ($parent.hasClass('maker-categories')) {
                $('.js-seelcted-product-info').empty();
                $('.js-seelcted-product-info').append($html).show();
                $('.js-placeholder-product').hide();
                $('.js-frag-search-product-module')
                    .find('.js-module-close')
                    .trigger('click');
            } else {
                $('.js-seelcted-oil-info').empty();
                $('.js-seelcted-oil-info').append($html).show();
                $('.js-placeholder').hide();
                $('.js-frag-search-oil-module')
                    .find('.js-module-close-search')
                    .trigger('click');
                $('.js-open-product-search-product-flyout').removeClass('disabled');
            }

            // update recommendation
            var loadURL = $(this).find('div').attr('data-recommendation-url');
            if (loadURL !== undefined) {
                $.ajax({
                    url: loadURL,
                    type: 'GET',
                    success: function (response) {
                        $('.fragrance-product-recommendation').html(response);
                    },
                });
            }
        });

        $('#select-fc-step1-unit li').on('click', function () {
            $(this).addClass('selected').siblings().removeClass('selected');
        });

        // $('#quickviewbutton').click(function (e) {
        //     e.preventDefault();
        //     let isSet = '';
        //     // quickview.show({
        //     //     url: $(this).data('link'),
        //     //     source: 'cart',
        //     //     isSet: isSet
        //     // });
        // });

        // ***************** Lye Calculator ******************

        var totalProductCount = $('#lc-dynacmic-grid>ul :input').length;

        // Step1 type selected data change event
        $('#select-lc-step1-type li').on('click', function () {
            // var selectedType = $(this).attr('data-value');
            $(this).addClass('selected').siblings().removeClass('selected');
            $('#select-lc-step1-type').addClass('lc-valid');
        });
        $('#select-lc-stepfinal-unit li').on('click', function () {
            // var selectedType = $(this).attr('data-value');
            $(this).addClass('selected').siblings().removeClass('selected');
            $('#select-lc-stepfinal-unit').addClass('lc-valid');
        });
        // Step1 unit selected data change event
        $('#select-lc-step1-unit li').on('click', function () {
            $(this).addClass('selected').siblings().removeClass('selected');
            var selectedUnit = $(this).attr('data-value');
            // if (selectedUnit === '-1') {
            //     $('#select-lc-step1-unit').focus();
            //     $('#select-lc-step1-unit')
            //         .css('border-color', 'red')
            //         .css('color', 'red')
            //         .removeClass('lc-valid');
            // } else {
            $('#select-lc-step1-unit').addClass('lc-valid');
            $('.lc-step1-selected-Percentage').css('display', 'none');
            $('.lc-step1-selected-Ounces-or-Grams').css('display', 'block');
            // Show or Hide Percentage Text box
            if (selectedUnit === 'Percentage') {
                $('.lc-stpe1-tb-dynamic').css('display', 'block');
                $('.lc-step1-selected-Percentage').css('display', 'block');
                $('.lc-step1-selected-Ounces-or-Grams').css('display', 'none');
            } else {
                $('.lc-stpe1-tb-dynamic').css('display', 'none');
            }
            // }
        });
        // Percentage text box data change event
        // eslint-disable-next-line consistent-return
        $('#tb-lc-step1').change(function () {
            var selectedAmount = $('#tb-lc-step1').val();
            if (
                selectedAmount === null ||
				selectedAmount === '' ||
				Number.isNaN(selectedAmount)
            ) {
                $('#tb-lc-step1').focus();
                $('#tb-lc-step1')
                    .css('border-color', 'red')
                    .css('color', 'red')
                    .removeClass('lc-valid');
                return false;
            }
            $('#tb-lc-step1')
                .css('border-color', '')
                .css('color', '')
                .addClass('lc-valid');
        });
        // Step1 Super fating Level selected data change event
        // eslint-disable-next-line consistent-return
        $('#select-lc-step1-sl').on('change', function () {
            var selectedSl = $('#select-lc-step1-sl option:selected').val();
            if (selectedSl === '-1') {
                $('#select-lc-step1-sl').focus();
                $('#select-lc-step1-sl')
                    .css('border-color', 'red')
                    .css('color', 'red')
                    .removeClass('lc-valid');
                return false;
            }
            $('#select-lc-step1-sl')
                .css('border-color', '')
                .css('color', '')
                .addClass('lc-valid');
        });

        // limit only 5 digits and numeric type only
        const step2inputs = document.querySelectorAll(
            '#lc-dynacmic-grid-row > input'
        );
        const updateValue = () => {
            step2inputs.forEach((input) => {
                input.addEventListener('input', () => {
                    if (input.value.length > input.maxLength)
                    // eslint-disable-next-line no-param-reassign
                        input.value = input.value.slice(0, input.maxLength);
                });
            });
        };

        window.addEventListener('DOMContentLoaded', updateValue);

        // Step1 next button click event
        $('#btn-lc-step1').click(function () {
            var res1 = $('#select-lc-step1-unit').hasClass('lc-valid');
            var res2 = $('#select-lc-step1-type').hasClass('lc-valid');
            var res3 = $('#select-lc-step1-sl').change().hasClass('lc-valid');
            var res4 = $('#tb-lc-step1').change().hasClass('lc-valid');
            var selectedUnit = $('#select-lc-step1-unit li.selected').attr(
                'data-value'
            );
            if (selectedUnit !== 'Percentage') res4 = true;

            if (res1 && res2 && res3 && res4) {
                // $('.lc-step1-default').css('display', 'none');
                // $('.lc-step2-label').css('display', 'none');
                // $('.lc-step1-label').css('display', 'block');
                // $('.lc-step2-default').css('display', 'block');
                // $('.lc-step2-fieldset').css('display', 'block');
                $('.nav-item .step1-tab').addClass('processed');
                $('.nav-item .step2-tab').parent().removeClass('disabled');
                $('.nav-item .step2-tab').trigger('click');

                // var selectedType = $('#select-lc-step1-type li.selected').val();
                // var selectedSl = $('#select-lc-step1-sl option:selected').val();

                // $('.lc-step1-type').html(selectedType);
                // $('.lc-step1-unit').html(selectedUnit);
                // $('.lc-step1-sl').html(selectedSl + ' Superfatting Level');
                var totalVal = '';
                if (selectedUnit === 'Percentage') {
                    totalVal = 'Total 0%';
                }
                $('#lc-dynacmic-calc-up').html(totalVal);
                $('#lc-dynacmic-calc-down').html(totalVal);
            }
        });
        // Step-2 next button click event
        // eslint-disable-next-line consistent-return
        $('#btn-lc-step2').click(function () {
            // reset data before appending
            $('#save-response').html('');
            $('.lc-step2-selected-data').html('');
            selectedProdVal = [];
            itemTotal = 0;
            var index;
            var data;

            var selectedUnit = $('#select-lc-step1-unit li.selected').attr(
                'data-value'
            );
            if (selectedUnit === 'Percentage' && precentTotal !== 100) {
                $('#lc-dynacmic-calc-error-up').removeClass('lc-dynacmic-calc-error');
                $('#lc-dynacmic-calc-error-down').removeClass('lc-dynacmic-calc-error');
                return false;
            }

            if (selectedUnit === 'Ounces') {
                aunit = ' oz';
                $('.meausrement-changer-tab')
                    .find('li a[data-value="oz"]')
                    .parent()
                    .addClass('active')
                    .siblings()
                    .removeClass('active');
                $('#select-lc-stepfinal-unit')
                    .find('li[data-value="Ounces"]')
                    .addClass('selected')
                    .siblings()
                    .removeClass('selected');
            } else if (selectedUnit === 'Grams') {
                aunit = ' g';
                $('.meausrement-changer-tab')
                    .find('li a[data-value="g"]')
                    .parent()
                    .addClass('active')
                    .siblings()
                    .removeClass('active');
                $('#select-lc-stepfinal-unit')
                    .find('li[data-value="Grams"]')
                    .addClass('selected')
                    .siblings()
                    .removeClass('selected');
            } else if (selectedUnit === 'Percentage') {
                var selectedRadio = $("input[name='radio-dynamic']:checked").val();
                aunit = ' ' + selectedRadio;
            } else {
                return false;
            }

            totalProductCount = $('#lc-dynacmic-grid>ul :input').length;

            var isValidData = true;
            for (var lindex = 0; lindex < totalProductCount; lindex++) {
                var enteredValue = $('#lc-dynacmic-grid>ul>li>div #tb-lc-step2')[lindex]
                    .value;
                if (enteredValue !== null && enteredValue !== '') {
                    isValidData = !Number.isNaN(enteredValue);
                    if (!isValidData) break;

                    if (parseFloat(enteredValue) > 0) {
                        var prodName = $('#lc-dynacmic-grid>ul>li>div #prodName')[lindex]
                            .innerHTML;
                        var prodId = $('#lc-dynacmic-grid>ul>li>div #prodId')[lindex]
                            .innerHTML;
                        var prodImg = $('#lc-dynacmic-grid>ul>li>div #prodIMG')[lindex].src;
                        var productOrderable = $(
                            '#lc-dynacmic-grid>ul>li>div #productOrderable'
                        )[lindex].innerHTML;

                        selectedProdVal.push({
                            productImage: prodImg,
                            ProductName: prodName,
                            Qty: enteredValue,
                            Percentage: 0,
                            ProdId: prodId,
                            productOrderable: productOrderable,
                        });

                        itemTotal += parseFloat(enteredValue);
                        $('.lc-step2-selected-data').append('<div>' + prodName + '</div>');
                    }
                }
            } // End of for loop

            if (!selectedProdVal.length > 0 || !isValidData) {
                $('.lc-step2-fieldset').css('border-color', 'red').css('color', 'red');
                return false;
            }

            var selectedType = $('#select-lc-step1-type li.selected').attr(
                'data-value'
            );
            var superFat = $('#select-lc-step1-sl option:selected').val();

            calculateLyeTotal(selectedType, superFat);

            PopulateFinalLabel();

            if (selectedUnit === 'Percentage') {
                var amount = $('#tb-lc-step1').val();
                itemTotal = 0;

                for (index = 0; index < selectedProdVal.length; index++) {
                    data = selectedProdVal[index];
                    data.Qty = (parseFloat(data.Qty) * parseFloat(amount)) / 100;
                    itemTotal += parseFloat(data.Qty);
                }

                calculateLyeTotal(selectedType, superFat);
            }

            // $('.lc-step2-label').css('display', 'block');
            // $('.lc-stepfinal-default').css('display', 'block');
            // $('.lc-stepfinal-fieldset').css('display', 'block');å
            // $('.lc-step2-default').css('display', 'none');

            $('.nav-item .step1-tab').addClass('processed');
            $('.nav-item .step2-tab').addClass('processed');
            $('.nav-item .result-tab').parent().removeClass('disabled');
            $('.nav-item .result-tab').trigger('click');

            CalculateLye(
                finalLyeTotal,
                finalLyeLiquidTotal,
                itemTotal,
                false,
                selectedType,
                aunit
            );

            // convert grams to ounce and save data
            if (aunit === ' g') {
                finalLyeTotal /= 28.34952;
                finalLyeLiquidTotal /= 28.34952;
                itemTotal /= 28.34952;
                for (index = 0; index < selectedProdVal.length; index++) {
                    data = selectedProdVal[index];
                    data.Qty = parseFloat(data.Qty) / 28.34952;
                }
            }
        });

        // eslint-disable-next-line consistent-return
        $('body').on(
            'change',
            '#lc-dynacmic-grid input.js-product-quantity-flyout',
            function (e) {
                // $('.lc-step2-fieldset').css('border-color', '').css('color', '');
                $('#lc-dynacmic-calc-error-up').addClass('lc-dynacmic-calc-error');
                // var className = e.target.className.split('.')[0];
                var selectedValue = $(this).val();
                if (
                    selectedValue !== null &&
					selectedValue !== '' &&
					(Number.isNaN(selectedValue) || parseFloat(selectedValue) <= 0)
                ) {
                    return false;
                }
                precentTotal = 0;
                var selectedUnit = $('#select-lc-step1-unit li.selected').attr(
                    'data-value'
                );
                if (selectedUnit === 'Percentage') {
                    totalProductCount = $('#lc-dynacmic-grid>ul :input').length;
                    for (var lindex = 0; lindex < totalProductCount; lindex++) {
                        var enteredValue = $('#lc-dynacmic-grid>ul>li>div #tb-lc-step2')[
                            lindex
                        ].value;
                        if (
                            enteredValue !== null &&
							enteredValue !== '' &&
							!Number.isNaN(enteredValue) &&
							parseFloat(enteredValue) > 0
                        ) {
                            precentTotal += parseFloat(enteredValue);
                        }
                    }
                    $('#lc-dynacmic-calc-up').html('Total ' + precentTotal + '%');
                    if (precentTotal === 100) {
                        $('#lc-dynacmic-calc-up').css('color', 'green');
                    } else {
                        $('#lc-dynacmic-calc-up').css('color', 'red');
                        $('#lc-dynacmic-calc-error-up').removeClass(
                            'lc-dynacmic-calc-error'
                        );
                    }
                } else {
                    $('#lc-dynacmic-calc-up').html('');
                }
            }
        );

        $('#btn-lc-stepfinal-resize').click(function () {
            var selectedTypeForResize = $(
                '.meausrement-changer-tab li.active a'
            ).data('value');
            if (selectedTypeForResize === 'oz') {
                $('.lc-stepfinal-resize-batch').find('.js-resize-grams').hide();
                $('.lc-stepfinal-resize-batch').find('.js-resize-ounce').show();
            } else {
                $('.lc-stepfinal-resize-batch').find('.js-resize-ounce').hide();
                $('.lc-stepfinal-resize-batch').find('.js-resize-grams').show();
            }
            $('.lc-stepfinal-resize-batch').css('display', 'block');
        });

        $('#btn-lc-stepfinal-og').click(function () {
            var selectedType = $('#select-lc-step1-type option:selected').val();
            if (aunit === ' g') {
                aunit = ' oz';
                CalculateLye(
                    finalLyeTotal,
                    finalLyeLiquidTotal,
                    itemTotal,
                    false,
                    selectedType
                );
                PopulateFinalLabel('Ounces');
            } else {
                aunit = ' g';
                CalculateLye(
                    finalLyeTotal * 28.3495231,
                    finalLyeLiquidTotal * 28.3495231,
                    itemTotal * 28.3495231,
                    true,
                    selectedType
                );
                PopulateFinalLabel('Grams');
            }
        });

        $('body').on(
            'click',
            '.meausrement-changer-tab li:not(.active) a',
            function () {
                var $this = $(this);
                var selectedType = $this.data('value');
                // var selectedType = $('#select-lc-step1-type li.selected').attr(
                //     'data-value'
                // );
                $this.parent().addClass('active').siblings().removeClass('active');
                if (selectedType === 'g') {
                    aunit = ' g';
                    CalculateLye(
                        finalLyeTotal * 28.3495231,
                        finalLyeLiquidTotal * 28.3495231,
                        itemTotal * 28.3495231,
                        true,
                        selectedType,
                        aunit
                    );
                    PopulateFinalLabel('Grams');
                } else {
                    aunit = ' oz';
                    CalculateLye(
                        finalLyeTotal,
                        finalLyeLiquidTotal,
                        itemTotal,
                        false,
                        selectedType,
                        aunit
                    );
                    PopulateFinalLabel('Ounces');
                }
            }
        );

        // lc step1 edit click
        $('#lc-step1-edit').click(function () {
            $('.lc-step1-default').css('display', 'block');
            $('.lc-step1-label').css('display', 'none');
            $('.lc-step2-fieldset').css('display', 'none');
            $('.lc-stepfinal-fieldset').css('display', 'none');
        });
        // lc step2 edit click
        $('#lc-step2-edit').click(function () {
            $('.lc-step2-default').css('display', 'block');
            $('.lc-step2-label').css('display', 'none');
            $('.lc-stepfinal-fieldset').css('display', 'none');
        });

        // Add Recipe to Customer Profile
        // eslint-disable-next-line consistent-return
        $('#lc-stepfinal-add').click(function () {
            var res1 = $('#tb-lc-stepfinal-rt').change().hasClass('lc-valid');
            // var res2 = $('#tb-lc-stepfinal-rn').change().hasClass('lc-valid');
            if (res1) {
                var recipe = populateLye();
                var respose = saveRecipe(recipe, 'lye');
                if (respose !== null) {
                    if (respose.Message !== undefined) {
                        if (respose.IsSuccess) {
                            $('#save-response').html(respose.Message).css('color', 'green');
                        } else {
                            $('#save-response').html(respose.Message).css('color', 'red');
                        }
                    }
                }
                $('#tb-lc-stepfinal-rt').val('');
                // $('#tb-lc-stepfinal-rn').val('');
                $('#tb-lc-stepfinal-rt').focus();
            } else {
                return false;
            }
        });
        // Print Recipe
        $('#lc-stepfinal-print').click(function () {
            printRecipe();
            return false;
        });
        // set input value in div, to print recipe
        $('#tb-lc-stepfinal-rt').blur(function () {
            $('#lc-recipe-title-print').text($('#tb-lc-stepfinal-rt').val());
        });
        // Recipe title text box change event
        // eslint-disable-next-line consistent-return
        $('#tb-lc-stepfinal-rt').change(function () {
            var title = $('#tb-lc-stepfinal-rt').val();
            if (title === null || title === '') {
                $('#tb-lc-stepfinal-rt').focus();
                $('#tb-lc-stepfinal-rt')
                    .css('border-color', 'red')
                    .css('color', 'red')
                    .removeClass('lc-valid');
                return false;
            }
            if (title !== null && title.length > 200) {
                $('#error-msg-title')
                    .html('Maximum allowed length is 200')
                    .css('color', 'red');
                $('#tb-lc-stepfinal-rt')
                    .css('border-color', 'red')
                    .css('color', 'red')
                    .removeClass('lc-valid');
            } else {
                $('#error-msg-title').html('').css('color', '');
                $('#tb-lc-stepfinal-rt')
                    .css('border-color', '')
                    .css('color', '')
                    .addClass('lc-valid');
            }
        });
        // Recipe note text box change event
        // eslint-disable-next-line consistent-return
        $('#tb-lc-stepfinal-rn').change(function () {
            var note = $('#tb-lc-stepfinal-rn').val();
            if (note.length > 1500) {
                $('#tb-lc-stepfinal-rn').focus();
                $('#error-msg-note')
                    .html('Maximum allowed length is 1500')
                    .css('color', 'red');
                $('#tb-lc-stepfinal-rn')
                    .css('border-color', 'red')
                    .css('color', 'red')
                    .removeClass('lc-valid');
                return false;
            }
            $('#tb-lc-stepfinal-rn')
                .css('border-color', '')
                .css('color', '')
                .addClass('lc-valid');
            $('#error-msg-note').html('').css('color', '');
        });

        // eslint-disable-next-line consistent-return
        $('#btn-lc-stepfinal-adjust').click(function () {
            var res = $('#tb-lc-stepfinal-adjust').change().hasClass('lc-valid');
            if (!res) return false;

            var amount = $('#tb-lc-stepfinal-adjust').val();
            var selectedUnit = $('#select-lc-stepfinal-unit li.selected').data(
                'value'
            );
            var selectedType = $('#select-lc-step1-type li.selected').data('value');
            var superFat = $('#select-lc-step1-sl option:selected').val();

            itemTotal = 0;

            for (var index = 0; index < selectedProdVal.length; index++) {
                var data = selectedProdVal[index];
                data.Qty = (parseFloat(data.Percentage) * parseFloat(amount)) / 100;
                itemTotal += parseFloat(data.Qty);
            }

            calculateLyeTotal(selectedType, superFat);

            if (
                (selectedUnit === 'Ounces' && aunit === ' oz') ||
				(selectedUnit === 'Grams' && aunit === ' g')
            ) {
                CalculateLye(
                    finalLyeTotal,
                    finalLyeLiquidTotal,
                    itemTotal,
                    false,
                    selectedType,
                    aunit
                );
            } else if (selectedUnit === 'Ounces' && aunit === ' g') {
                aunit = ' oz';
                CalculateLye(
                    finalLyeTotal,
                    finalLyeLiquidTotal,
                    itemTotal,
                    false,
                    selectedType,
                    aunit
                );
            } else {
                aunit = ' g';
                CalculateLye(
                    finalLyeTotal * 28.3495231,
                    finalLyeLiquidTotal * 28.3495231,
                    itemTotal * 28.3495231,
                    true,
                    selectedType,
                    aunit
                );
            }
            $('#resizeBatchModal').modal('toggle');
            PopulateFinalLabel(selectedUnit);
        });

        // eslint-disable-next-line consistent-return
        $('#tb-lc-stepfinal-adjust').change(function () {
            var selectedAmount = $('#tb-lc-stepfinal-adjust').val();
            if (
                selectedAmount === null ||
				selectedAmount === '' ||
				Number.isNaN(selectedAmount)
            ) {
                $('#tb-lc-stepfinal-adjust').focus();
                $('#tb-lc-stepfinal-adjust')
                    .css('border-color', 'red')
                    .css('color', 'red')
                    .removeClass('lc-valid');
                return false;
            }
            $('#tb-lc-stepfinal-adjust')
                .css('border-color', '')
                .css('color', '')
                .addClass('lc-valid');
        });

        $('body').on(
            'click',
            '.js-open-product-search-product-flyout',
            function (e) {
                e.preventDefault();
                if ($('.js-frag-search-product-module').length > 0) {
                    return false;
                }
                $('.js-lye-search-product-module').addClass('show-module');
                $('#lyeProductsPanel').addClass('active');
                $('body').addClass('side-panel-open');
                $('html, body').css('overflow', 'hidden');
            }
        );

        $('body').on(
            'click',
            '.js-open-product-search-product-flyout:not(.disabled)',
            function (e) {
                e.preventDefault();
                $('.js-frag-search-product-module').addClass('show-module');
                $('#fragProductsPanel').addClass('active');
                $('body').addClass('side-panel-open');
                $('html, body').css('overflow', 'hidden');
            }
        );

        $('body').on('click', '.js-open-product-search-oil-flyout', function (e) {
            e.preventDefault();
            $('.js-frag-search-oil-module').addClass('show-module');
            $('#fragProductsPanelOil').addClass('active');
            // $('body').addClass('side-panel-open');
            // $('html, body').css('overflow', 'hidden');
        });

        $('body').on(
            'click',
            '#lc-dynacmic-grid-flyout .js-add-product-flyout',
            function () {
                $(this).siblings('.js-product-quantity-flyout').val(1);
                $(this).siblings('.js-product-quantity-flyout').removeClass('d-none');
                $(this).siblings('.js-delete-product-flyout').removeClass('d-none');
                $(this).addClass('d-none');
                // add products to the main content area for calculation processing
                $('#lc-dynacmic-grid ul').append($(this).closest('li').clone());
                var classToRemove = $(this)
                    .closest('#lc-dynacmic-grid-row-flyout')
                    .attr('class');
                $('#lc-dynacmic-grid')
                    .find('.' + classToRemove)
                    .attr('id', 'lc-dynacmic-grid-row');
                updateCount();
                loadLyeRecommendation();
            }
        );
        $('body').on(
            'click',
            '#lc-dynacmic-grid-flyout .js-delete-product-flyout',
            function () {
                $(this).siblings('.js-product-quantity-flyout').val('');
                $(this).siblings('.js-product-quantity-flyout').addClass('d-none');
                $(this).siblings('.js-add-product-flyout').removeClass('d-none');
                $(this).addClass('d-none');

                // remove the product from dynamic grid as well
                var classToRemove = $(this)
                    .closest('#lc-dynacmic-grid-row-flyout')
                    .attr('class');
                $('#lc-dynacmic-grid')
                    .find('.' + classToRemove)
                    .parent()
                    .remove();
                updateCount();
                loadLyeRecommendation();
            }
        );

        $('body').on(
            'click',
            '#lc-dynacmic-grid .js-delete-product-flyout',
            function () {
                var classToRemove = $(this)
                    .closest('#lc-dynacmic-grid-row')
                    .attr('class');
                // $('#lc-dynacmic-grid-flyout').find('.' + classToRemove).parent().remove();
                var $elmOnFlyout = $('#lc-dynacmic-grid-flyout').find(
                    '.' + classToRemove
                );
                $elmOnFlyout.find('.js-product-quantity-flyout').val('');
                $elmOnFlyout.find('.js-product-quantity-flyout').addClass('d-none');
                $elmOnFlyout.find('.js-add-product-flyout').removeClass('d-none');
                $elmOnFlyout.find('.js-delete-product-flyout').addClass('d-none');
                $(this).parents('li').remove();
                updateCount();
                loadLyeRecommendation();
            }
        );

        // logic to filter search results
        $('body').on('input', '#js-tb-lc-step2-search', function () {
            var filter = $(this).val();
            $('#lc-dynacmic-grid-flyout li').each(function () {
                if ($(this).text().search(new RegExp(filter, 'i')) < 0) {
                    $(this).hide();
                } else {
                    $(this).show();
                }
            });
        });

        // logic to filter search results
        $('body').on('input', '#js-tb-fc-step2-search', function () {
            var filter = $(this).val();
            $('#fc-dynacmic-grid-flyout li').each(function () {
                if ($(this).text().search(new RegExp(filter, 'i')) < 0) {
                    $(this).hide();
                } else {
                    $(this).show();
                }
            });

            if ($(this).hasClass('js-frag-search')) {
                if (filter !== '') {
                    $(this).parent().addClass('written');
                } else {
                    $(this).parent().removeClass('written');
                }
            }
        });

        $('body').on('click', '.js-module-close-search', function () {
            $('.js-frag-search-oil-module').removeClass('show-module');
            $('#js-tb-fc-step2-search').val('');
            $('#fc-dynacmic-grid-flyout li').show();
        });

        $('body').on('click', '.results-qa .results-question', function () {
            $(this).parent().toggleClass('open');
        });

        $('#lc-dynacmic-grid-flyout .js-product-quantity-flyout').on(
            'change',
            function () {
                // remove the product from dynamic grid as well
                var currentVal = $(this).val();
                var classToRemove = $(this)
                    .closest('#lc-dynacmic-grid-row-flyout')
                    .attr('class');
                $('#lc-dynacmic-grid')
                    .find('.' + classToRemove)
                    .find('.js-product-quantity-flyout')
                    .val(currentVal);
                updateCount();
            }
        );

        $('body').on(
            'change',
            '#lc-dynacmic-grid .js-product-quantity-flyout',
            function () {
                var val = $(this).val();
                var classToRemove = $(this)
                    .closest('#lc-dynacmic-grid-row')
                    .attr('class');
                // $('#lc-dynacmic-grid-flyout').find('.' + classToRemove).parent().remove();
                var $elmOnFlyout = $('#lc-dynacmic-grid-flyout').find(
                    '.' + classToRemove
                );
                $elmOnFlyout.find('.js-product-quantity-flyout').val(val);
            }
        );

        $('body').on('click', 'a.add-btn', function (e) {
            // e.preventDefault();
            // var addToCartUrl = $('.lye-calculator-wrapper').data('add-action');
            // var pid = $(this).data('sku');
            // $.spinner().start();
            // var pidsObj;
            // // $('body').trigger('product:beforeAddToCart', this);
            // var form = {
            //     pid: pid,
            //     pidsObj: pidsObj,
            //     childProducts: JSON.stringify([]),
            //     quantity: 1,
            // };
            // $(this).trigger('updateAddToCartFormData', form);
            // if (addToCartUrl) {
            //     $.ajax({
            //         url: addToCartUrl,
            //         method: 'POST',
            //         data: form,
            //         success: function (data) {
            //             $('body').trigger('product:afterAddToCart', data);
            //             if (isMobile) {
            //                 handlePostCartAdd(data);
            //             } else {
            //                 $('.minicart').trigger('click');
            //             }
            //             $.spinner().stop();
            //             miniCartReportingUrl(data.reportingURL);
            //         },
            //         error: function () {
            //             $.spinner().stop();
            //         },
            //     });
            //     return false;
            // }
        });

        $('body').on('click', '.js-add-all-product-to-cart', function (e) {
            e.preventDefault();
            var addToCartUrl = $(this).data('add-all-to-cart');
            var pids = [];
            $.spinner().start();
            var pidsObj;
            $('a.add-btn:visible').each(function () {
                pids.push($(this).data('sku'));
            });

            // $('body').trigger('product:beforeAddToCart', this);
            var form = {
                pid: JSON.stringify(pids),
                pidsObj: pidsObj,
                childProducts: JSON.stringify([]),
                quantity: 1,
            };

            $(this).trigger('updateAddToCartFormData', form);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: function (data) {
                        $('body').trigger('product:afterAddToCart', data);
                        if (isMobile) {
                            handlePostCartAdd(data);
                        } else {
                            $('.minicart').trigger('click');
                        }
                        $.spinner().stop();
                        miniCartReportingUrl(data.reportingURL);
                    },
                    error: function () {
                        $.spinner().stop();
                    },
                });
                return false;
            }
        });
    } // end-if for calculator name-space check
};
